import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import BodyRow from './BodyRow';
import BodyCell from './BodyCell';
// eslint-disable-next-line import/named,import/no-cycle
import { TableContext } from '../../CustomTable';

export default function TableBody({ withBorderRadius = '0' }) {
  const ctx = useContext(TableContext);

  return (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        borderRadius: withBorderRadius,
        ...ctx.bodyStyles
      }}
    >
      {ctx.data.map((row) => (
        <BodyRow key={row.Id} row={row}>
          {ctx.columns().map((column) => (
            <BodyCell key={column.id} alignment={column?.alignment}>
              {column.value(row)}
            </BodyCell>
          ))}
        </BodyRow>
      ))}
    </div>
  );
}
